import type { DataTableFilter, MoreMenuCategory } from '@odo/shared-ui';
import { PO_BILLING_STATUSES, PO_FULFILLMENT_STATUSES, poStatusOptions } from './poStatus';

const FULFILLMENT_OPTIONS = poStatusOptions(PO_FULFILLMENT_STATUSES);
const BILLING_OPTIONS = poStatusOptions(PO_BILLING_STATUSES);

export interface FilterOptionRef {
    value: string;
    label: string;
    sublabel?: string;
    keywords?: readonly string[];
}

export interface BuildPurchaseOrderFiltersArgs {
    vendorId: string[];
    practiceFilter: string | null;
    vendorOptions: FilterOptionRef[];
    practiceOptions: FilterOptionRef[];
    /** Set means the instance is practice-scoped, so the practice pill is dropped. */
    practiceScoped: boolean;
    setVendor: (value: string[]) => void;
    setPractice: (value: string | null) => void;
}

// Vendor and Practice are the only pills pinned to the bar; Shipping and
// Billing live in "More filters" (see buildPurchaseOrderMoreFilters).
export function buildPurchaseOrderFilters({
    vendorId,
    practiceFilter,
    vendorOptions,
    practiceOptions,
    practiceScoped,
    setVendor,
    setPractice
}: BuildPurchaseOrderFiltersArgs): DataTableFilter[] {
    return [
        {
            key: 'vendorId',
            label: 'Vendor',
            multiple: true,
            options: vendorOptions,
            value: vendorId,
            onChange: setVendor,
            workQueueVariant: true,
            align: 'right',
            searchable: true
        },
        ...(practiceScoped
            ? []
            : [
                  {
                      key: 'practiceId',
                      label: 'Practice',
                      options: practiceOptions,
                      value: practiceFilter,
                      onChange: setPractice,
                      workQueueVariant: true,
                      align: 'right',
                      searchable: true
                  } satisfies DataTableFilter
              ])
    ];
}

export interface BuildPurchaseOrderMoreFiltersArgs {
    fulfillmentStatus: string[];
    billingStatus: string[];
    setFulfillmentStatus: (value: string[]) => void;
    setBillingStatus: (value: string[]) => void;
}

// Secondary axes, tucked behind the More menu (see MoreFiltersMenu / the
// work-queue toolbar for the same pattern).
export function buildPurchaseOrderMoreFilters({
    fulfillmentStatus,
    billingStatus,
    setFulfillmentStatus,
    setBillingStatus
}: BuildPurchaseOrderMoreFiltersArgs): MoreMenuCategory[] {
    return [
        {
            key: 'fulfillmentStatus',
            label: 'Shipping',
            options: FULFILLMENT_OPTIONS,
            selectedOptions: fulfillmentStatus,
            onChange: setFulfillmentStatus
        },
        {
            key: 'billingStatus',
            label: 'Billing',
            options: BILLING_OPTIONS,
            selectedOptions: billingStatus,
            onChange: setBillingStatus
        }
    ];
}
